import { BaseService } from '@/modules/Core/services/BaseService'
import type { AxiosResponse } from 'axios'
import type { IResponseApi} from '@/modules/Core/interfaces/api/IApis'
import type { IFormActaCompra, IMediActa, IPayloadMediActaCierre } from '../interfaces/IMediActas'
import type { IMediTipoInventario } from '../interfaces/tablas/IMediMedicamentosGenericos'

export class MedicamentoActaService extends BaseService<IMediActa> {
  constructor () {
    super({
      baseUrl: 'medicines/medicines/records/'
    })
  }
  async createClosingRecord (data: IPayloadMediActaCierre): Promise<AxiosResponse<IResponseApi<string>>> {
    return this.http.post<IResponseApi<string>>(`/createClosingRecord`, data).catch(this.errorHandle)
  }
  async createPurchaseRecord (data: IFormActaCompra, tipo: IMediTipoInventario): Promise<AxiosResponse<IResponseApi<string>>> {
    return this.http.post<IResponseApi<string>>(`/createPurchaseRecord/${tipo}`, data).catch(this.errorHandle)
  }
  async createOutputRecord (data: Record<string, unknown>): Promise<AxiosResponse<IResponseApi<string>>> {
    return this.http.post<IResponseApi<string>>(`/createOutputRecord`, data).catch(this.errorHandle)
  }
  async downloadClosingRecordTemplate(tipo: IMediTipoInventario): Promise<AxiosResponse<ArrayBuffer>> {
    return this.http.get<ArrayBuffer>(`/downloadClosingRecordTemplate/${tipo}`, {
      responseType: 'arraybuffer',
      headers: {
        'Access-Control-Max-Age': '0'
      }
    })
  } 
}
